import { LoadingButton } from '@mui/lab';
import { Tooltip } from '@mui/material';
import PropTypes from 'prop-types';
import { enqueueSnackbar } from 'notistack';

import useInfoDialog from 'common/hooks/useInfoDialog';
import { useDispatch } from 'react-redux';
import { markOrderForExternalProcessing } from 'store/thunks/patientThunks';

const ReviewOrderVerificationButton = ({
  orderId,
  mpi,
  disabled,
  isManualOrder,
  isRefillOrder,
}) => {
  const { InfoDialog, showInfoDialog } = useInfoDialog();
  const dispatch = useDispatch();

  const handleMarkAsReview = () => {
    showInfoDialog({
      title: 'Confirm Processing External',
      message: `Are you sure you want to mark this order to be processed external?`,
      isWarning: true,
      callback: () =>
        dispatch(markOrderForExternalProcessing({ mpi, orderId })).then((isMarkedReview) => {
          if (isMarkedReview) {
            enqueueSnackbar(`Order ${orderId} marked for processing external`, {
              variant: 'error',
            });
          }
        }),
      cancelable: true,
      confirmButtonText: 'Yes',
    });
  };

  const title =
    (isManualOrder && 'Manual orders do not support external processing functionality.') ||
    (isRefillOrder && 'Refill orders do not support external processing functionality.') ||
    '';

  return (
    <>
      <InfoDialog />
      <Tooltip title={title} placement='bottom' arrow>
        <span>
          <LoadingButton
            size='small'
            color='error'
            onClick={handleMarkAsReview}
            variant='outlined'
            disabled={disabled || isManualOrder || isRefillOrder}
            sx={{
              px: 1,
              fontSize: '0.75rem',
              minHeight: '30px',
              lineHeight: 'normal',
            }}
          >
            Process External
          </LoadingButton>
        </span>
      </Tooltip>
    </>
  );
};

ReviewOrderVerificationButton.propTypes = {
  orderId: PropTypes.string.isRequired,
  mpi: PropTypes.string.isRequired,
  disabled: PropTypes.bool,
  isManualOrder: PropTypes.bool.isRequired,
  isRefillOrder: PropTypes.bool.isRequired,
};

ReviewOrderVerificationButton.defaultProps = {
  disabled: false,
};

export default ReviewOrderVerificationButton;
